// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.containerSec {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.lookup-form, .amount-currency-form {
  display: flex;
  flex-direction: column;
  gap: 15px; 
}

input[type="text"],
input[type="number"],
select {
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.containerSec button {
  padding: 10px;
  font-size: 16px;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.summary-details {
  text-align: left;
}

.summary-details p {
  margin: 10px 0;
}


.containerSec button:hover {
  background-color: #0056b3;
}



.containerSec {
  max-width: 500px;
  margin: 50px auto;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.containerSec h3 {
  text-align: center;
  color: #007bff;
}
.containerSec h1 {
  text-align: center;
  color: #007bff;
}

.lookup-form, .student-details {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.containerSec input[type="text"],
input[type="number"],
select {
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.containerSec button {
  padding: 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.containerSec button:hover {
  background: #0056b3;
}


/* 

.form-containerSec {
    max-width: 400px;
    margin: 50px auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 8px;
  }
  
  .input-block {
    margin-bottom: 15px;
  }
  
  .input-block label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
  }
  
  .input-block input {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
  }
  
  .button {
    padding: 10px 15px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .button:hover {
    background-color: #0056b3;
  }
  
  .error {
    color: red;
    margin-bottom: 10px;
  }
   */`, "",{"version":3,"sources":["webpack://./src/Components/Payments/StudentNumberForm/StudentNumberForm.css"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA2CI","sourcesContent":["\n.containerSec {\n  max-width: 500px;\n  margin: 0 auto;\n  padding: 20px;\n  text-align: center;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n}\n\n.lookup-form, .amount-currency-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px; \n}\n\ninput[type=\"text\"],\ninput[type=\"number\"],\nselect {\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.containerSec button {\n  padding: 10px;\n  font-size: 16px;\n  background-color: #007BFF;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.summary-details {\n  text-align: left;\n}\n\n.summary-details p {\n  margin: 10px 0;\n}\n\n\n.containerSec button:hover {\n  background-color: #0056b3;\n}\n\n\n\n.containerSec {\n  max-width: 500px;\n  margin: 50px auto;\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n}\n\n.containerSec h3 {\n  text-align: center;\n  color: #007bff;\n}\n.containerSec h1 {\n  text-align: center;\n  color: #007bff;\n}\n\n.lookup-form, .student-details {\n  display: flex;\n  flex-direction: column;\n  margin-top: 20px;\n}\n\n.containerSec input[type=\"text\"],\ninput[type=\"number\"],\nselect {\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.containerSec button {\n  padding: 10px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.containerSec button:hover {\n  background: #0056b3;\n}\n\n\n/* \n\n.form-containerSec {\n    max-width: 400px;\n    margin: 50px auto;\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n  }\n  \n  .input-block {\n    margin-bottom: 15px;\n  }\n  \n  .input-block label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: bold;\n  }\n  \n  .input-block input {\n    width: 100%;\n    padding: 8px;\n    box-sizing: border-box;\n  }\n  \n  .button {\n    padding: 10px 15px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .button:hover {\n    background-color: #0056b3;\n  }\n  \n  .error {\n    color: red;\n    margin-bottom: 10px;\n  }\n   */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
